export const ISO_DATE_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]';
export const SHORT_DAY_AND_SHORT_MONTH_AND_DAY_NUMBER = 'ddd, MMM D';
